// extracted by mini-css-extract-plugin
export var footer = "_pu-5";
export var fulfillmentInput = "_pu-0";
export var shipDateInput = "_pu-1";
export var shipmentModal = "_pu-2";
export var shipmentModalContent = "_pu-3";
export var tableContainer = "_pu-4";